<template>
  <div class="index">
    <div class="index">
      <el-card class="index-container" shadow="never">
        <p class="index-container-title" style="padding: 0px">客户信息</p>
        <table border="" class="index-container-table">
          <tr>
            <td class="index-container-table-label">客户姓名</td>
            <td class="index-container-table-text">
              {{ clientForm && clientForm.children && clientForm.children.length ?  clientForm.children[0].childName : ''}}
              <!-- {{ clientForm.userName }} -->
            </td>
            <td class="index-container-table-label">联系电话</td>
            <td class="index-container-table-text">
              {{ clientForm.mobilePhone }}
            </td>
            <td class="index-container-table-label">详细地址</td>
            <td class="index-container-table-text">
              {{ clientForm.address }}
            </td>
          </tr>
          <tr>
            <td class="index-container-table-label">客户备注</td>
            <td class="index-container-table-text" colspan="5">
              {{ clientForm.userRemark }}
            </td>
          </tr>
        </table>
        <el-table v-if="currentBelong == 2"
          :header-cell-style="{
            'text-align': 'center',
            background: '#edf3fe',
            color: '#0d6fb8',
          }"
          :cell-style="{ 'text-align': 'center' }"
          :data="clientForm.children"
        >
          <el-table-column label="会员姓名" prop="childName"></el-table-column>
          <el-table-column label="孩子性别" prop="gender">
            <template slot-scope="{ row }">
              <div>
                {{ row.gender == 0 ? "男" : row.gender == 1 ? "女" : "未知" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="出生年月" prop="birthday"></el-table-column>
          <el-table-column label="乳名" prop="nickName"></el-table-column>
          <el-table-column label="渠道" prop="channel"></el-table-column>
          <el-table-column label="来源" prop="source"></el-table-column>
        </el-table>
      </el-card>
      <!-- <el-card class="index-container" shadow="never">
        <p class="index-container-title" style="padding: 0px">孩子信息</p>
        <el-table
          class="index-container-table"
          :header-cell-style="{
            'text-align': 'center',
            background: '#edf3fe',
            color: '#0d6fb8',
          }"
          :cell-style="{ 'text-align': 'center' }"
          :data="clientForm.children"
        >
          <el-table-column label="会员姓名" prop="childName"></el-table-column>
          <el-table-column label="孩子性别" prop="gender"></el-table-column>
          <el-table-column label="出生年月" prop="birthday"></el-table-column>
          <el-table-column label="乳名" prop="nickName"></el-table-column>
          <el-table-column label="渠道" prop="channel"></el-table-column>
          <el-table-column label="来源" prop="source"></el-table-column>
        </el-table>
      </el-card> -->
      <el-card
        class="index-container"
        shadow="never"
        v-if="clientForm.followInfo && clientForm.followInfo.card"
      >
        <p class="index-container-title" style="padding: 0px">会员卡信息</p>
        <table border="" class="index-container-table">
          <tr>
            <td class="index-container-table-label">会员卡名称</td>
            <td class="index-container-table-text">
              {{ clientForm.followInfo.card.cardName }}
            </td>
            <td class="index-container-table-label">会员卡种类</td>
            <td class="index-container-table-text">
              {{ clientForm.followInfo.card.cardKind }}
            </td>
            <td class="index-container-table-label">总课时(正价/赠送)</td>
            <td class="index-container-table-text">
              <!-- {{ clientForm.followInfo.card.totalCount }} -->
              {{ clientForm.followInfo.card.totalCount }}({{
                clientForm.followInfo.card.totalLessonCount
              }}/{{ clientForm.followInfo.card.totalGiveCount }} )
            </td>
          </tr>
          <tr>
            <td class="index-container-table-label">剩余课时(正价/赠送)</td>
            <td class="index-container-table-text">
              <!-- {{ clientForm.followInfo.card.residueCount }} -->
              {{ clientForm.followInfo.card.residueCount }}({{
                clientForm.followInfo.card.remainingClass
              }}/{{ clientForm.followInfo.card.remainingGiveCount }} )
            </td>
            <td class="index-container-table-label">有效期</td>
            <td class="index-container-table-text">
              {{ clientForm.followInfo.card.expirationDate }}
            </td>
          </tr>
        </table>
      </el-card>
      <el-card class="index-container" shadow="never">
        <p class="index-container-title" style="padding: 0px">跟进信息</p>
        <div class="index-container-table" v-if="clientForm.followInfo">
          <el-form
            ref="registerRef"
            label-width="120px"
            :rules="rules"
            :model="clientForm"
          >
            <el-row>
              <el-col :span="24">
                <!-- :disabled="masterId ? true : false" -->
                <el-form-item label="跟进描述">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="clientForm.followInfo.followContent"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="当前阶段:" prop="followInfo.currentStage">
                  <el-select
                    v-model="clientForm.followInfo.currentStage"
                    filterable=""
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in currentStageList"
                      :key="item.v"
                      :label="item.des"
                      :value="item.v"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="currentBelong != 2">
                <el-form-item label="意向级别:">
                  <el-select
                    v-model="clientForm.followInfo.intentionLevel"
                    filterable=""
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in intentionLevelList"
                      :key="item.state"
                      :label="item.name"
                      :value="item.state"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col
                :span="12"
                v-for="(cur, curIx) in clientForm.followInfo.workers"
                :key="curIx"
              >
                <el-form-item label="当前跟进人:">
                  <el-select
                    filterable=""
                    v-model="cur.workerId"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in workersList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <i
                    v-if="clientForm.followInfo.workers.length - 1 == curIx"
                    class="el-icon-circle-plus"
                    style="font-size: 20px; cursor: pointer"
                    @click="handleAddPerson"
                  ></i>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label=" 跟进反馈">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="clientForm.followInfo.feedbackResult"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="录音:">
                  <div style="width: 665px;display: flex;align-items: center;">
                    <soundRecording
                      ref="soundRecord"
                      @clickRecStop="clickRecStop"
                      @clickRecClear="clickRecClear"
                    />
                    <div v-if="audio" style="margin-left: 20px;">
                      <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
                        <source :src="audio" />
                      </audio>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>

    <el-dialog
      title="口令"
      :visible.sync="visibleCommand"
      width="500px"
      center
      append-to-body
    >
      <el-form ref="registerRefV" label-width="120px">
        <el-form-item label="输入口令:" prop="userPhone">
          <el-input
            style="width: 270px"
            placeholder=""
            readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleCommand = false">取 消</el-button>
        <el-button type="primary" @click="onBtnhandleUpdate()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { adminFollowrecordList } from "@/api/PotentialCustomers";
import soundRecording from "@/components/soundRecording";

export default {
  components: {
    soundRecording,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    workersList: {
      type: Array,
      default: () => [],
    },
    masterId: {
      type: [Number, String],
      default: null,
    },
    currentBelong: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      genderOptions: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      activeName: "first",
      formData: {},
      visibleCommand: false,
      clientForm: this.clientInfo,
      intentionLevelList: [
        {
          state: 1,
          name: "A+",
        },
        {
          state: 2,
          name: "A",
        },
        {
          state: 3,
          name: "B+",
        },
        {
          state: 4,
          name: "B",
        },
        {
          state: 5,
          name: "C",
        },
        {
          state: 6,
          name: "D",
        },
      ],
      currentStageList: [],
      followStateList: [
        {
          state: 1,
          name: "短期跟进",
        },
        {
          state: 2,
          name: "长期跟进",
        },
      ],
      rules: {
        // followContent: [
        //   {
        //     required: true,
        //     message: "请输入跟进内容标题",
        //     trigger: ["change", "blur"],
        //   },
        // ],
        "followInfo.currentStage": [
          {
            required: true,
            message: "请选择跟进阶段",
            trigger: ["change", "blur"],
          },
        ],
      },
      logListPageNum: 1,
      logListPageSize: 10,
      logListPageTotalPage: 0,
      recordList: [],
      audio: "",
    };
  },
  watch: {
    clientInfo: {
      handler(newVal, oldVal) {
        this.init();
        this.clientForm = newVal;
        this.clickRecClear()
        if(this.$refs.audio && this.$refs.audio.src){
          this.$refs.audio.src = ''
        }
        if(this.$refs.soundRecord && this.$refs.soundRecord.audio){
          this.$refs.soundRecord.audio = ''
        }
        if (!this.clientForm.followInfo) {
          this.clientForm.followInfo = {
            followContent: undefined,
            feedbackResult: undefined,
            currentStage: null,
            intentionLevel: undefined,
            intentionLevel: undefined,
            feedbackAudio: undefined,
            workers: [
              {
                workers: null,
              },
            ],
          };
        }
      },
    },
  },

  methods: {
    init() {
      switch (this.currentBelong) {
        case 2:
          this.currentStageList = [
            { v: 10, des: "首次跟进" },
            { v: 11, des: "跟进中" },
            { v: 12, des: "跟进结果" },
            { v: 13, des: "跟进完成" },
          ];
          break;
        default:
          this.currentStageList = [
            { v: 1, des: "建立联系" },
            { v: 2, des: "确认意向" },
            { v: 3, des: "承诺到访" },
            { v: 4, des: "预约试听" },
            { v: 5, des: "完成试听" },
            { v: 6, des: "完成缴费" },
            { v: 7, des: "放弃" },
            { v: 8, des: "重新跟进" },
          ];
      }
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop();
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio;
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false;
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer);
        }, 500);
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio;
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false;
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer);
        }, 500);
      }
    },
    clickRecClear() {
      this.audio = "";
    },
    handleClick(tab, event) {
      this.$emit("cancle", this.activeName);
      if (this.activeName == "second") {
        if (this.masterId) {
          this.getFollowRecordAxios();
        }
      }
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    // 获取跟进记录详情
    async getFollowRecordAxios() {
      let params = {
        pageNum: this.logListPageNum,
        pageSize: this.logListPageSize,
        masterId: this.masterId,
      };
      const response = await adminFollowrecordList(params);
      if (response.code == 20000) {
        let data = response.data;
        this.recordList =
          this.logListPageNum == 1
            ? data.list
            : this.recordList.concat(data.list);
        this.logListPageTotalPage = data.totalPage;
      }
    },
    // 检查滚动并触发加载更多数据
    checkScroll() {
      const content = this.$refs.scrollContent;
      if (
        content.scrollHeight - content.clientHeight - content.scrollTop < 20 &&
        this.logListPageTotalPage > this.logListPageNum
      ) {
        this.logListPageNum++; // 增加页数
        this.getFollowRecordAxios();
      }
    },
    handleAddPerson() {
      this.clientForm.followInfo.workers.push({
        workers: null,
      });
    },
    handleUpdate() {
      // this.visibleCommand = true;
    },
    onBtnhandleUpdate() {
      this.visibleCommand = false;
      this.$emit("onBtnhandleUpdate");
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  &-container {
    background: #ffffff;
    border-radius: 8px;
    padding: 20px 25px 10px;
    margin-bottom: 20px;
    /deep/ .el-card__body {
      padding: 0px;
    }
    &-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #282d30;
    }
    &-table {
      border-collapse: collapse;
      border-color: #ededed;
      margin-top: 10px;
      tr {
        td {
          padding: 20px 0;
        }
      }
      &-label {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0e6fb8;
        background: #cedef5;
        width: 110px;
      }
      &-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #74798c;
        width: 250px;
        padding-left: 12px !important;
      }
    }
  }
  &-table {
    width: 100%;
    border-collapse: collapse;
    border-color: #e4e1e1;
    tr {
      td {
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
    &-label {
      background-color: #e9e1e1;
    }
  }
  &-steps {
    margin-top: 20px;
    /deep/ .el-step__description {
      color: #333333;
    }
    /deep/ .el-step__line {
      background: #b6b3b3;
    }
    &-icon {
      width: 25px;
      height: 25px;
    }
    /deep/ .el-step__icon.is-text {
      border: none;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff;
  }
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
/deep/ .el-dialog__body{
  padding: 12px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/marketing-manager/potential-customers/components/client-follow.vue